/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Library Ad configuration for StackAdapt campaign. This is used for Ad Tags.
*/
export class V3StackAdaptLibraryAd {
    /**
    * Ad Tag ID for the library ad
    */
    'adTagId'?: string;
    /**
    * Campaign IDs for the library ad
    */
    'campaignIds'?: Array<string>;
    /**
    * Ad ID
    */
    'id'?: string;
    /**
    * Ad name
    */
    'name'?: string;
    /**
    * Click URL for the ad
    */
    'clickUrl'?: string;
    /**
    * Brand name
    */
    'brandname'?: string;
    /**
    * Subtype of the ad. Default to 'DEFAULT'
    */
    'subtype'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "adTagId",
            "baseName": "adTagId",
            "type": "string",
            "format": ""
        },
        {
            "name": "campaignIds",
            "baseName": "campaignIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "clickUrl",
            "baseName": "clickUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "brandname",
            "baseName": "brandname",
            "type": "string",
            "format": ""
        },
        {
            "name": "subtype",
            "baseName": "subtype",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptLibraryAd.attributeTypeMap;
    }

    public constructor() {
    }
}

